import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreHeading,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { navigationRoutes } from '@/Shared/ui/routers'
import { useUserData } from '@/User/ui/context'
import { homeTranslation } from '../homeTranslation'

interface StickerSpaceProps {
  origin: string
  largeVersion?: boolean
}

export const StickerSpace = ({
  origin,
  largeVersion = false,
}: StickerSpaceProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchant } = useUserData()
  return (
    <OreCardContainer>
      <OreCardWrapper>
        <OreStack placeContent="stretch" space="small">
          <OreHeading as="h2" size="headline-md">
            {t(homeTranslation.module.sticker.title)}
          </OreHeading>

          <OreDivider />

          <OreStack
            placeContent="space-between"
            direction={largeVersion ? 'row' : 'column'}
          >
            <OreStack placeContent="start" space="xsmall">
              <OreStack
                placeContent="start"
                placeItems="center"
                space="2xsmall"
                direction="row"
              >
                <OreText bold>
                  {t(homeTranslation.module.sticker.description)}
                </OreText>
              </OreStack>
            </OreStack>
              <OreStack placeContent="start" space="small">
                {merchant.isNursery && 
                  origin === navigationRoutes.home &&
                  <OreButton
                    onClick={() =>
                      navigate(navigationRoutes.storeStickers, {
                        state: { origin: origin },
                      })
                    }
                  >
                    {t(homeTranslation.module.sticker.button)}
                  </OreButton>
                }
              </OreStack>
          </OreStack>
        </OreStack>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
